// extracted by mini-css-extract-plugin
export default {"sectionHeader":"ReviewsSection_sectionHeader__hge2b","reviewList":"ReviewsSection_reviewList__ZNyzX"};